import { parse } from "querystring";
import * as React from "react";
import "./LoginPage.css";
import { RouteChildrenProps } from "react-router";
import { Form, Button, Alert } from "react-bootstrap";
import firebase from "../firebase";

interface LoginPageState {
    oobCode: string;
    email: string;
    newPassword: string;
    errorMessage: string;
    success: boolean;
    fatalError: boolean;
}

export default class PasswordResetPage extends React.Component<RouteChildrenProps, LoginPageState> {
    private onSubmitBound: (ev: React.MouseEvent) => void;
    private onChangeNewPasswordBound: (ev: React.FormEvent<any>) => void;

    constructor(props: RouteChildrenProps) {
        super(props);
        this.onSubmitBound = this.onSubmit.bind(this);
        this.onChangeNewPasswordBound = this.onChangePassword.bind(this);

        this.state = {
            oobCode: "",
            email: "",
            newPassword: "",
            errorMessage: "",
            success: false,
            fatalError: false
        }
    }

    async componentWillMount() {
        const params = parse(window.location.search.slice(1));
        const oobCode = params["oobCode"];
        if (typeof oobCode !== "string") {
            this.setState({
                fatalError: true
            });
            return;
        }
        try {
            const email = await firebase.auth().verifyPasswordResetCode(oobCode);
            this.setState({
                oobCode,
                email
            });
        } catch (e) {
            this.setState({
                fatalError: true
            });
        }
    }
    async onSubmit(ev: React.MouseEvent): Promise<void> {
        ev.preventDefault();
        const {newPassword, oobCode} = this.state;
        if (newPassword.length < 8) {
            this.setState({
                errorMessage: "パスワードは8文字以上で入力してください"
            });
            return;
        }
        try {
            await firebase.auth().confirmPasswordReset(oobCode, newPassword);
            this.setState({
                success: true,
                errorMessage: ""
            });
        } catch (e) {
            this.setState({errorMessage: e.message});
        }
    }

    onChangePassword(ev: React.FormEvent<any>): void {
        const value: string = (ev.target as HTMLInputElement).value;
        this.setState({newPassword: value});
    }

    render() {
        if (this.state.fatalError) {
            return <div>{"不正な呼び出しです"}</div>;
        }
        const alert = this.state.errorMessage ? (<Alert variant="danger">{this.state.errorMessage}</Alert>) : null;
        const successAlert = this.state.success ? (<Alert variant="success">{"パスワードの更新が完了しました。新しいパスワードでログインできるようになりました。"}</Alert>) : null;
        return (
            <div className="login-box">
                <div className="login-box-body">
                    <p className="text-center">
                        <h1>パスワード再設定</h1>
                    </p>
                    <Form>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>メールアドレス</Form.Label>
                            <Form.Control type="email" value={this.state.email} disabled/>
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>新しいパスワード</Form.Label>
                            <Form.Control type="password" placeholder="Password" value={this.state.newPassword} onChange={this.onChangeNewPasswordBound} disabled={this.state.success} />
                        </Form.Group>
                        {alert}
                        <p className="text-center">
                            <Button variant="primary" type="submit" onClick={this.onSubmitBound} disabled={this.state.success}>
                                保存
                            </Button>
                        </p>
                        {successAlert}
                    </Form>
                </div>
            </div>
        );
    }
}
